import type { RouteRecordRaw } from 'vue-router'
import { ROUTES } from '@/router/routes.enum'
import { ACTION_ROLES } from '@/utils/constants'
import { requireAuthenticatedUser } from '@/router/guards'

export const orderRoutes: RouteRecordRaw[] = [
  {
    path: '/orders',
    name: ROUTES.ORDERS,
    component: () => import('@/modules/orders/views/OrdersIndex.view.vue'),
    beforeEnter: requireAuthenticatedUser,
    meta: { roles: ACTION_ROLES.ORDERS_VIEW }
  },
  {
    path: '/orders/:id',
    name: ROUTES.ORDER_DETAILS,
    component: () => import('@/modules/orders/views/OrderDetails.view.vue'),
    beforeEnter: requireAuthenticatedUser,
    meta: { roles: ACTION_ROLES.ORDERS_VIEW }
  },
  {
    path: '/orders_test_page',
    name: ROUTES.ORDERS_TEST_PAGE,
    component: () => import('@/modules/orders/views/OrdersTestPage.view.vue'),
    beforeEnter: requireAuthenticatedUser,
    meta: { roles: ACTION_ROLES.ORDERS_TEST_PAGE_VIEW }
  }
]
